module.exports = __webpack_public_path__ + "img/Posts-icon.1175db89.svg";